import { apiGet, apiPut } from './client';

export interface AlarmSoundSettings {
  enabled: boolean;
  warning_sound_url: string | null;
  caution_sound_url: string | null;
  warning_tone_frequency_hz: number;
  caution_tone_frequency_hz: number;
  volume: number;
  duration_ms: number;
}

export interface AlarmSoundSettingsUpdateInput {
  enabled?: boolean;
  warning_sound_url?: string | null;
  caution_sound_url?: string | null;
  warning_tone_frequency_hz?: number;
  caution_tone_frequency_hz?: number;
  volume?: number;
  duration_ms?: number;
}

export const DEFAULT_ALARM_SOUND_SETTINGS: AlarmSoundSettings = {
  enabled: false,
  warning_sound_url: null,
  caution_sound_url: null,
  warning_tone_frequency_hz: 880,
  caution_tone_frequency_hz: 660,
  volume: 0.45,
  duration_ms: 650,
};

/** 브라우저 알림음 설정을 조회합니다. */
export function fetchAlarmSoundSettings() {
  return apiGet<AlarmSoundSettings>({
    path: '/common/alarm-sound-settings',
  });
}

/** 브라우저 알림음 설정을 저장합니다. */
export function updateAlarmSoundSettings(input: AlarmSoundSettingsUpdateInput) {
  return apiPut<AlarmSoundSettings>({
    path: '/common/alarm-sound-settings',
    body: { ...input },
  });
}
